import Icon from '../../../components/AppIcon';

const SecurityIndicators = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      text: 'SSL Encrypted',
      color: 'var(--color-success)'
    },
    {
      icon: 'Lock',
      text: 'Secure Authentication',
      color: 'var(--color-primary)'
    },
    {
      icon: 'FileCheck',
      text: 'Data Protected',
      color: 'var(--color-accent)'
    }
  ];

  return (
    <div className="mt-8 pt-6 border-t border-border">
      <div className="flex flex-wrap items-center justify-center gap-6">
        {securityFeatures?.map((feature, index) => (
          <div key={index} className="flex items-center gap-2">
            <Icon name={feature?.icon} size={16} color={feature?.color} />
            <span className="text-xs text-muted-foreground font-medium">
              {feature?.text}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityIndicators;